<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style scoped lang="scss">
@media screen and (max-width: 640px) {
  .area li {
    margin-left: auto;
    margin-right: auto;
  }
}
.container10 {
  margin-top: 80px;
}
.container10 h1 {
  font-size: 70px;
  color: #014492;
}
.cons {
  display: none;
}
.container10 h2 {
  font-size: 40px;
  color: #014492;
}
.container10 .a {
  width: 1200px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span {
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.no-indent {
  .desc {
    text-indent: 0;
  }
}
.wrap-tec .lists li {
  width: 33.3%;
}
@media screen and (max-width: 640px) {
  .wrap-tec .lists li {
    width: 100% !important;
    p {
      margin: 5px auto !important;
    }
  }
}
</style>
<template>
  <div class="wrap wrap-tec">
    <!--    <div class="banner">-->
    <!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
    <!--      <div class="info">-->
    <!--        <div class="container">-->
    <!--          <h1>全长转录组测序iso-seq</h1>-->
    <!--          <h2 class="mt10">Full-length transcriptome sequencing iso-seq（全面·经典）</h2>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="container container10">
      <h1>全长转录组测序iso-seq</h1>
      <h2 class="mt10">
        Full-length Transcriptome Sequencing iso-seq（全面·经典）
      </h2>
      <div class="a"><span></span></div>
    </div>
    <div
      class="breads container"
      style="overflow: auto; line-height: 48px; padding-left: 10px"
    >
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">
        全长转录组测序（Iso-Seq）是基于三代PacBio单分子实时测序技术，凭借超长读长的优势（平均读长10Kb），可以轻松跨越从5'末端到3'-Poly
        A尾的完整转录本，无需打断RNA分子，从而获得高质量全长转录本序列。
      </p>
      <p class="desc mt10">
        通过全长转录组测序能够更精准地得到mRNA全长序列及完整结构信息，可以对新基因及其Isoform进行更全面的研究，克服了转录本二代测序拼接短、转录本结构不完整的缺点，实现对可变剪接、同源异构体、同源基因、等位基因、融合基因等精确分析。
      </p>
      <en-title title="应用领域" enTitle="Application" />
      <service-table
        :tableColumn="applicationColumn"
        :tableData="applicationData"
      />
      <en-title title="技术参数" enTitle="Specifications" />
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png" />
          <h4>测序平台及策略</h4>
          <p>PacBio</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_8.png" />
          <h4>项目周期</h4>
          <p>30个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>30G</p>
        </li> -->
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png" />
          <h4>数据质量</h4>
          <p>Q30＞80% , Q20＞85%</p>
        </li>
      </ul>
      <en-title title="技术路线" enTitle="Testing Workflow" />
      <div class="tc con"><img src="@/assets/images/full_1.png" /></div>
      <div class="tc cons" style="margin-top: 20px">
        <img src="@/assets/images/full_1.png" />
      </div>
      <en-title title="研究内容" enTitle="Bioinformatics Service" />
      <service-table
        :tableColumn="hasTableColumn"
        :tableData="hasTableData"
        :headerCellStyle="headerCellStyle"
      />
      <service-table
        style="margin-top:4vw"
        :tableColumn="tableColumn"
        :tableData="tableData"
        :headerCellStyle="headerCellStyle"
        :tableSpanMethod="tableSpanMethod"
      />
    </section>
    <new-consult
      title="样本制备与寄样"
      enTitle="Sample Requirement and Shipment"
      :samplingText="samplingText"
      :typeList="['sampling']"
    />
    <!-- <qk-consult type="Virus"/> -->
  </div>
</template>
<script>
import bread from "@/components/bread";
import ServiceTable from "./components/serviceTable";
import ApplicationIcon from "./components/applicationIcon";
export default {
  inject: ["reload"],
  components: {
    bread,
    ServiceTable,
    ApplicationIcon,
  },
  data() {
    return {
      samplingText: "擎科生物全长转录组测序目前接收细胞、动物组织、植物组织、真菌菌体、细菌菌体、血液等组织样本与提取好的total RNA。",
      applicationColumn: [
        {
          label: "在动植物方面",
          prop: "method1",
        },
        {
          label: "在医学方面",
          prop: "method2",
        },
      ],
      applicationData: [
        {
          method1: "1 挖掘生物胁迫和非生物胁迫对动植物的生理，发育影响，结合RNA-seq筛选不 同环境下的差异表达基因或转录本，增加对胁迫和耐受相关调控网络的理解",
          method2: "1 获得病变组织/细胞的全长转录组，筛选治疗靶点/研究预后相关信息",
        },
        {
          method1: "2 准确识别不同时期的转录本结构变化",
          method2: "2 发现复杂疾病中的基因结构变异和融合基因，鉴定肿瘤/疾病中的特异性Isoform",
        },
        {
          method1: "3 研究生物合成或代谢机制，鉴定完整转录本",
          method2: "3 进行药物响应研究或基因变异与疾病耐药性的相关分析",
        },
        {
          method1: "",
          method2: "4 可变剪切因子分析，驱动基因的结构变异，疾病关键候选基因的筛选等",
        },
      ],
      hasTableColumn: [
        {
          prop: "method1",
          html: true,
        },
        {
          label: "有参考基因组全长转录组测序标准生信分析",
          prop: "method2",
          html: true,
        },
      ],
      hasTableData: [
        {
          method1: "1) 测序Reads质量控制（QV）",
          method2: "11) lncRNA预测",
        },
        {
          method1: "2) 全长转录本评估",
          method2: "12) lncRNA靶基因预测",
        },
        {
          method1: "3) Isoform序列聚类",
          method2: "13) SSR分析",
        },
        {
          method1: "4) 转录本去冗余",
          method2: "14) CDS预测",
        },
        {
          method1: "5) 基因结构优化",
          method2: "15) 可变多聚腺苷酸化分析（APA）",
        },
        {
          method1: "6) 新转录本预测",
          method2: "16) 转录因子预测",
        },
        {
          method1: "7) 可变剪接分析",
          method2: "17) 不同样品可变剪接差异对比（两个或以上样品）",
        },
        {
          method1: "8) 转录本功能注释",
          method2: "18) 不同样品融合转录本差异对比（两个或以上样品）",
        },
        {
          method1: "9) 融合转录本分析",
          method2: "19) 不同样品可变多聚腺苷酸化（APA）差异对比（两个或以上样品）",
        },
        {
          method1: "10) 基因家族分析",
          method2: "",
        },
        
      ],
      tableColumn: [
        {
          prop: "method1",
          html: true,
        },
        {
          label: "无参考基因组全长转录组测序标准生信分析",
          prop: "method2",
          html: true,
        },
      ],
      tableData: [
        {
          method1: `1) 三代测序数据产出统计
                    <p class="ml17 mt10">1.1 CCS序列统计</p>
                    <p class="ml17 mt10">1.2 全长序列统计</p>
                    <p class="ml17 mt10">1.3 isoform 序列聚类</p>`,
          method2: `6) LncRNA预测
                    <p class="ml17 mt10">6.1 CPC分析</p>
                    <p class="ml17 mt10">6.2 CPAT分析</p>
                    <p class="ml17 mt10">6.3 CNCI分析</p>
                    <p class="ml17 mt10">6.4 pfam蛋白结构域分析</p>`,
        },
        {
          method1: "2) 转录本去冗余",
          method2: "7) LncRNA靶向转录本预测",
        },
        {
          method1: "3) 可变剪接分析  ",
          method2: "8) 转录因子分析",
        },
        {
          method1: "4) SSR分析",
          method2: "9) 转录本功能注释（NR、GO、KEGG、COG、Swiss-Prot）",
        },
        {
          method1: "5) 编码区序列预测",
          method2: "",
        },
        
      ],
    };
  },
  created() {
    this.reload();
  },
  methods: {
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        row[1].colSpan = 2;
        if (columnIndex === 0) {
          return {
            display: "none",
          };
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/tec/full_length.vue